import React, { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { CircularProgress } from "@mui/material";

function ContactUs() {
  const [loading, setLoading] = useState(false);

  const SvgIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      className="mr-2 h-[18px] w-[18px] sm:h-[28px] sm:w-[28px] "
      viewBox="0 0 36 36"
    >
      <path data-name="Path 1156" d="M0 0h36v36H0z" style={{ fill: "none" }} />
      <path
        data-name="Path 1157"
        d="M15.058 2A10.213 10.213 0 0 0 5 12.376c0 7.782 10.058 19.27 10.058 19.27s10.058-11.488 10.058-19.27A10.213 10.213 0 0 0 15.058 2z"
        transform="translate(2.942 1.177)"
        style={{ fill: "#bbb" }}
      />
      <circle
        data-name="Ellipse 2"
        cx="5.971"
        cy="5.971"
        r="5.971"
        transform="translate(12.029 7.647)"
        style={{ fill: "#1c1c1c" }}
      />
    </svg>
  );
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [formDataError, setFormDataError] = useState({
    name: false,
    email: false,
    message: false,
  });
  const onChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name.toLowerCase()]: value,
    }));

    setFormDataError((prevError) => ({
      ...prevError,
      [name.toLowerCase()]: false,
    }));
  };
  const handleSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[^0-9]*$/;

    const isEmailValid = emailRegex.test(formData.email);
    const isNameValid = nameRegex.test(formData.name);

    setFormDataError({
      name: formData.name === "" || !isNameValid,
      email: formData.email === "" || !isEmailValid,
      message: formData.message === "",
    });

    if (formData.name && isNameValid && isEmailValid && formData.message) {
      try {
        setLoading(true);
        const data = {
          email: formData.email,
          message: formData.message,
          name: formData.name,
        };
        await axios
          .post("https://portal.fitstreak.club/api/api/users/queries", {
            data: data,
          })
          .then((response) => {
            setLoading(false);
            if (response.status === 201) {
              toast.success("Message sent");
            } else {
              toast.error("Failed to send the message");
            }
          });
      } catch (error) {
        setLoading(false);
        toast.error("An error occurred");
      } finally {
        setLoading(false);
      }
    } else {
      console.error("Form validation failed");
      return;
    }
  };

  return (
    <div className="mt-6 md:mt-10 flex flex-col lg:flex-row w-full  sm:w-[96%]  lg:w-[96%] xl:w-[85%] 2xl:w-[80%] h-auto item-center justify-between m-auto  py-10">
      {loading && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-10"
          style={{ backdropFilter: "blur(5px)" }}
        >
          <CircularProgress size="3rem" style={{ color: "red" }} />
        </div>
      )}
      <div className="flex flex-col p-10 sm:w-[75%] m-auto lg:m-0 w-full lg:w-[500px] h-auto  text-white  ">
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl 2xl:text-3xl font-bold">
          Contact Us
        </h1>
        <p className="text-md sm:text-lg md:text-lg lg:text-base xl:text-lg mt-4 md:mt-6 text-nav_option">
          Have questions or ready to join? Reach out to us today! Our team at
          Fit Streak is here to assist you with all your fitness needs.
        </p>
        <div className="mt-3 w-full ">
          <div className="w-full mt-4">
            <label className="w-full mt-30   text-left lg:text-md">Name </label>
            <input
              type="text"
              className={`w-full lg:h-[40px] bg-[#303030] mt-4 rounded-[4px] p-2 outline-none focus:border-red focus:border ${
                formDataError.name ? "border border-red" : ""
              } `}
              name="Name"
              placeholder="Enter you name"
              onChange={onChange}
            />
            <span
              className={`w-full text-red lg:h-[20px] text-semibold mt-0 rounded-[4px] p-1 outline-none lg:text-base text-sm flex justify-end ${
                formDataError.name ? "flex" : "hidden"
              }`}
            >
              please enter your name or valid name
            </span>
          </div>
          <div className="w-full mt-4">
            <label className="w-full mt-30   text-left lg:text-md">
              Email{" "}
            </label>
            <input
              type="email"
              className={`w-full lg:h-[40px] bg-[#303030] mt-4 rounded-[4px] p-2 outline-none focus:border-red focus:border ${
                formDataError.email ? "border border-red" : ""
              } `}
              name="Email"
              placeholder="Enter you email"
              onChange={onChange}
            />
            <span
              className={`w-full text-red lg:h-[20px] text-semibold mt-0 rounded-[4px] p-1 outline-none lg:text-base text-sm flex justify-end ${
                formDataError.email ? "flex" : "hidden"
              }`}
            >
              please enter your email or valid email
            </span>
          </div>
          <div className="w-full mt-4">
            <label className="w-full mt-30   text-left lg:text-md">
              Message{" "}
            </label>
            <textarea
              onChange={onChange}
              className={`w-full lg:h-[40px] bg-[#303030] mt-4 rounded-[4px] p-2 outline-none focus:border-red focus:border ${
                formDataError.message ? "border border-red" : ""
              } `}
              name="Message"
              placeholder="Enter your message"
              rows={6}
            ></textarea>
            <span
              className={`w-full text-red lg:h-[20px] text-semibold mt-0 rounded-[4px] p-1 outline-none lg:text-base text-sm flex justify-end ${
                formDataError.message ? "flex" : "hidden"
              }`}
            >
              please enter your message
            </span>
          </div>
          <div className="flex justify-end float:right  mt-4  w-[100%]">
            <button
              className="py-2 px-6 bg-red xxs:text-sm text-center w-max rounded-[5px] font-semibold"
              onClick={handleSubmit}
              disabled={loading}
            >
              SUBMIT
            </button>
          </div>
        </div>
      </div>
      <div className="flex  flex-col w-full p-10   h-auto lg:w-[700px]  lg:h-full justify-center item-center ">
        <img
          src="/images/map.png"
          alt="maleTrainer"
          className="w-[360px] sm:w-[500px] h-auto md:w-[700px] object-cover m-auto cursor-pointer"
          onClick={() => {
            const isMobile = /iPhone|iPad|iPod|Android/i.test(
              navigator.userAgent
            );
            const isSmallScreen = window.innerWidth < 780; // Check for screen width

            if (isMobile) {
              window.location.href =
                "geo:0,0?q=Near+UBL+Bank,+Central+District+Bahria+Orchard+Lahore";
            } else {
              // For larger screens, open in Google Maps web
              window.open(
                "https://www.google.com/maps/place/Fit+Streak/@31.3174086,74.2195511,17z/data=!3m1!4b1!4m6!3m5!1s0x3919abb3ea59059f:0x3ba4cef1ed9fb3e1!8m2!3d31.3174086!4d74.2195511!16s%2Fg%2F11lz54kgyv?entry=ttu&g_ep=EgoyMDI1MDEyMi4wIKXMDSoASAFQAw%3D%3D",
                "_blank"
              );
            }
          }}
        />
        <h1 className="text-sm sm:text-lg md:text-lg lg:text-base xl:text-lg mt-4 md:mt-6 text-nav_option flex flex-row  m-auto">
          {" "}
          <SvgIcon /> Plaza 147, Central Commercial, Bahria Orchard, Lahore
        </h1>
      </div>
    </div>
  );
}

export default ContactUs;
